<template>
    <PatientHistory :Type="AppServiceID" />
</template> 
<script>
import PatientHistory from '@/components/Dental/PatientHistorySearch.vue'
import LayoutDefault from '@/Common/Default/DefaultLayout.vue';
export default {
    data: function (){
        return {
            AppServiceID : '',            
        }
    },
    components: {
        PatientHistory
    },
    created: function() {
        this.$emit('update:layout', LayoutDefault);
        this.AppServiceID = this.$store.getters.GetDentalID;
    },    
    beforeCreate: function() {
        this.$store.dispatch('AddServiceID',this.$store.getters.GetDentalID);
        this.$store.dispatch('GetMenuItems',this.$store.getters.GetDentalID);
    },
}
</script>

<style>

</style>
